import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Svg from './Svg';

const Footer = ({ prevHash, onBack, onSave, canBack, canNext, onReset, submitting }) => (
  <footer id="footer" className="footer-shop mt-auto py-1">
      <div className="footer-row">
        <div className="col left-col">
          <button disabled={!canBack || submitting} type="button" onClick={onBack} className="btn btn-text px-0">
            <Svg name="shop-prev" />
            <span className="ms-2">Back</span>
          </button>
        </div>
        <div className="col center-col">
          <button disabled={submitting} className={`btn btn-primary ${canNext ? null : 'fake-disabled'}`} type="submit">
            <span className="me-2">Next</span>
            <Svg name={submitting ? 'spinner' : 'shop-next'} spin={submitting} />
          </button>
        </div>
        <div className="col right-col">
          <button
            disabled={submitting}
            className="btn btn-text d-lg-inline-block px-0"
            type="button"
            onClick={() => onReset('Would you like to start over? Please note all answers in your current session will be deleted. Your previously completed submissions will not be affected.')}
          >
            Reset
          </button>
          <button
            disabled={submitting}
            type="button"
            onClick={onSave}
            className="btn btn-light px-3 save-exit"
          >
            {prevHash ? 'Back to cart' : 'Save & Exit'}
          </button>
        </div>
      </div>
  </footer>
);

Footer.propTypes = {
  prevHash: PropTypes.string,
  onBack: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  canBack: PropTypes.bool.isRequired,
  canNext: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default memo(Footer);
